import React, { useState, useEffect } from "react";
import { Formik, Field, Form, FieldArray, ErrorMessage } from "formik";
import "react-toastify/dist/ReactToastify.css";
import * as Yup from "yup";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import { values } from "lodash";
import DepartmentForm from "../Forms/DepartmentForm";
import BranchForm from "../Forms/BranchForm";
import DesignationForm from "../Forms/DesignationForm";
import {
  CustomSelect,
  getData,
  postData,
} from "../Commonfunction/CommonFunction";
import CommonModal from "../common/CommonModal";
import { useUser } from "../Commonfunction/UserContext";
import PermissionMessage from "../common/PermissionMessage";
import CenteredLoading from "../common/CenteredLoading";
import { checkPermission } from "../Commonfunction/NewPermission";
import "../../assets/style/EmployeForm.css";
import { AiOutlineDelete, AiOutlinePlus } from "react-icons/ai";
import { CiSquarePlus } from "react-icons/ci";
import { GrAction, GrDocumentImage } from "react-icons/gr";
import { IoArrowBack, IoDocumentAttach } from "react-icons/io5";
import { FaCloudUploadAlt } from "react-icons/fa";
import { MdAddToPhotos, MdOutlinePreview } from "react-icons/md";
import { HiMiniDocumentMagnifyingGlass } from "react-icons/hi2";
import { RiDeleteBinFill } from "react-icons/ri";

const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

export default function AddEditCpa() {
  const [loading, setLoading] = useState(false);
  const [allDataLoad, setAllDataLoad] = useState(false);
  const [singleData, setSingleData] = useState();
  const navigate = useNavigate();
  const { id } = useParams();

  // ----- Fixed: Renamed state variables to avoid hook naming confusion ------
  const [dropdownList, setDropdownList] = useState();
  const [cityList, setCityList] = useState([]);
  // Added state to track selected state for city lookup
  const [selectedState, setSelectedState] = useState(null);

  const validationSchema = Yup.object().shape({
    company_name: Yup.string().required("Company Name is required"),
    firm_size: Yup.string().required("Firm Size is required"),
    email: Yup.string()
      .email("Invalid email")
      .required("Company email is required"),
    billing_email: Yup.string()
      .email("Invalid email")
      .required("Billing Email is required"),
    // mobile_no: Yup.string().required("Mobile number is required"),
    mobile_no: Yup.string().test(
      "length",
      "Mobile number must be 10 digits long.",
      (value) => {
        if (!value) return false;
        // Remove any non-digit characters (e.g., spaces, dashes)
        const digits = value.replace(/\D/g, "");
        return digits.length >= 11;
      }
    ),
    document_info: Yup.array().of(
      Yup.object().shape({
        document_name: Yup.string().required("Document info is required"),
        company_documents: Yup.string().required(
          "Company documents is required"
        ),
      })
    ),
  });

  const singleCpcData = async () => {
    try {
      const result = await getData(`/api/get-cpc/${id}`);
      if (result.success) {
        setSingleData(result.data);
        // Set selected state when data is loaded
        if (result.data?.state) {
          setSelectedState(result.data.state);
        }
        setAllDataLoad(false);
      } else {
        toast.error(result.message);
        setAllDataLoad(false);
      }
    } catch (error) {
      console.log("Error: ", error);
      setAllDataLoad(false);
    }
  };

  // Fixed: Renamed function to avoid hook naming pattern
  const fetchCityData = async (stateId) => {
    try {
      const request_url = `/api/get-city-by-state/${stateId}`;
      const result = await getData(request_url);
      if (result.success) {
        setCityList(result.data);
      }
    } catch (error) {
      console.log("Error fetching city data:", error);
    }
  };

  // Effect to load cities when selected state changes
  useEffect(() => {
    if (selectedState) {
      fetchCityData(selectedState);
    }
  }, [selectedState]);

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const request_url = id ? `/api/update-cpc/${id}` : "/api/create-cpc";
      const postDataResult = await postData(request_url, values);
      if (postDataResult.success) {
        toast.success(postDataResult.message);
        navigate("/all-cpa");
        setLoading(false);
      } else {
        toast.error(postDataResult.message);
        setLoading(false);
      }
    } catch (error) {
      // Handle error
      toast.error(error.postDataResult?.data?.message || "An error occurred");
    } finally {
      setLoading(false); // Set loading state to false
    }
  };

  useEffect(() => {
    if (id) {
      setAllDataLoad(true);
      singleCpcData();
    }
  }, [id]);

  const initialValues = {
    company_name: id ? singleData?.company_name : "",
    dba_name: id ? singleData?.dba_name : "",
    gst_ein_number: id ? singleData?.gst_ein_number : "",
    firm_size: id ? singleData?.firm_size : "",
    email: id ? singleData?.email : "",
    billing_email: id ? singleData?.billing_email : "",
    mobile_no: id ? singleData?.mobile_no : "",
    landline_no: id ? singleData?.landline_no : "",
    fax_no: id ? singleData?.fax_no : "",
    website_url: id ? singleData?.website_url : "",
    state: id ? singleData?.state : "",
    document_info: id
      ? singleData?.documents
      : [
          {
            document_name: "",
            company_documents: "",
          },
          {
            document_name: "",
            company_documents: "",
          },
          {
            document_name: "",
            company_documents: "",
          },
          {
            document_name: "",
            company_documents: "",
          },
          {
            document_name: "",
            company_documents: "",
          },
        ],
  };

  const handleFileChange = async (event, index, setFieldValue) => {
    const file = event.currentTarget.files[0];
    setFieldValue(`document_info.${index}.file`, file);
    if (file) {
      const base64 = await fileToBase64(file);
      setFieldValue(`document_info.${index}.company_documents`, base64);
    }
  };

  // Handle state change from form
  const handleStateChange = (stateId, setFieldValue) => {
    setFieldValue('state', stateId);
    setSelectedState(stateId);
  };

  return (
    <div className="bg-white">
      <Formik
        initialValues={initialValues}
        enableReinitialize
        validationSchema={validationSchema}
        onSubmit={(values) => {
          if (loading) {
            toast.warning("Data Migration In Progress..Please Wait");
          } else {
            handleSubmit(values);
          }
        }}
      >
        {({ errors, touched, setFieldValue, values }) => (
          <Form className="modern-form-container">
            <div className="heading-wrapper">
              <button
                type="button"
                className="back-button"
                onClick={() => navigate("/Cpalisting")}
                title="Back to Employees"
              >
                <IoArrowBack />
              </button>
              <h2 className="form-heading">{id ? "Edit CPA" : "Add CPA"}</h2>
            </div>
            <div className="form-section">
              <h2 className="form-title">CPA Details</h2>
              <div className="form-grid">
                <div className="form-group">
                  <label htmlFor="company_name">Company Name</label>
                  <Field
                    id="company_name"
                    className="form-control"
                    name="company_name"
                    type="text"
                    placeholder="Please enter company name"
                  />
                  <ErrorMessage
                    name="company_name"
                    component="div"
                    className="error-message"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="dba_name">DBA Name</label>
                  <Field
                    id="dba_name"
                    className="form-control"
                    name="dba_name"
                    type="text"
                    placeholder="Please enter DBA name"
                  />
                  <ErrorMessage
                    name="dba_name"
                    component="div"
                    className="error-message"
                  />
                </div>
                
                {/* State field that updates both form value and triggers city load */}
                <div className="form-group">
                  <label htmlFor="state">State</label>
                  <Field
                    id="state"
                    className="form-control"
                    name="state"
                    as="select"
                    onChange={(e) => handleStateChange(e.target.value, setFieldValue)}
                  >
                    <option value="">Select State</option>
                    {/* Render state options here */}
                    {dropdownList?.states?.map((state) => (
                      <option key={state.id} value={state.id}>
                        {state.name}
                      </option>
                    ))}
                  </Field>
                </div>
                
                {/* Conditional GST/EIN field */}
                {values.country === "in" ? (
                  <div className="form-group">
                    <label htmlFor="gst"> GST No</label>
                    <Field
                      id="gst"
                      className="form-control mb-2"
                      name="gst"
                      type="text"
                      placeholder="Please enter GST"
                    />
                    <ErrorMessage
                      name="gst"
                      component="div"
                      className="error-message"
                    />
                  </div>
                ) : (
                  <div className="form-group">
                    <label htmlFor="gst_ein_number">EIN</label>
                    <Field
                      id="gst_ein_number"
                      className="form-control"
                      name="gst_ein_number"
                      mask="11-1111111"
                      type="text"
                      placeholder="Please enter EIN"
                    />
                    <ErrorMessage
                      name="gst_ein_number"
                      component="div"
                      className="error-message"
                    />
                  </div>
                )}

                <div className="form-group">
                  <label htmlFor="firm_size">Firm Size</label>
                  <Field
                    id="firm_size"
                    className="form-control"
                    name="firm_size"
                    type="number"
                    placeholder="Please enter firm size"
                  />
                  <ErrorMessage
                    name="firm_size"
                    component="div"
                    className="error-message"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email"> Company Email</label>
                  <Field
                    id="email"
                    className="form-control"
                    name="email"
                    type="email"
                    placeholder="Please enter company email"
                  />
                  <ErrorMessage
                    name="email"
                    component="div"
                    className="error-message"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="billing_email"> Billing Email</label>
                  <Field
                    id="billing_email"
                    className="form-control"
                    name="billing_email"
                    type="email"
                    placeholder="Please enter company email"
                  />

                  <ErrorMessage
                    name="billing_email"
                    component="div"
                    className="error-message"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="mobile_no"> Mobile No</label>
                  <PhoneInput
                    name={"mobile_no"}
                    country="us"
                    inputStyle={{ width: "100%" }}
                    inputProps={{
                      name: "mobile",
                      required: true,
                    }}
                    value={values.mobile_no || ""} // Set default value here
                    onChange={(phone) => setFieldValue(`mobile_no`, phone)}
                  />
                  <ErrorMessage
                    name="mobile_no"
                    component="div"
                    className="error-message"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="street_2"> Landline No.</label>
                  <Field
                    id="landline_no"
                    className="form-control"
                    name="landline_no"
                    type="number"
                    placeholder="Please enter landline no"
                  />
                  <ErrorMessage
                    name="landline_no"
                    component="div"
                    className="error-message"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="fax_no"> Fax No.</label>
                  <Field
                    id="fax_no"
                    className="form-control"
                    name="fax_no"
                    type="text"
                    placeholder="Please enter fax no"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="website_url">Website URL</label>
                  <Field
                    id="website_url"
                    className="form-control"
                    name="website_url"
                    type="text"
                    placeholder="Please enter website URL"
                  />
                </div>
              </div>

              <h2 className="form-title">CPA Documents</h2>
              <div className="usa-accordion__content document-section">
                <FieldArray name="document_info">
                  {({ insert, remove, push }) => (
                    <>
                      <table className="document-table">
                        <thead>
                          <tr>
                            <th>
                              <IoDocumentAttach /> Document Name{" "}
                              <span className="required">*</span>
                            </th>
                            <th>
                              <FaCloudUploadAlt /> Upload{" "}
                              <span className="required">*</span>
                            </th>
                            <th>
                              <HiMiniDocumentMagnifyingGlass /> Preview
                            </th>
                            <th>
                              <GrAction /> Action
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {values.document_info?.map((doc, index) => (
                            <tr key={index}>
                              {/* Document Name */}
                              <td>
                                <Field
                                  className="modern-input"
                                  name={`document_info.${index}.document_name`}
                                  type="text"
                                  placeholder="e.g., ID Proof"
                                />
                                {errors.document_info?.[index]
                                  ?.document_name &&
                                  touched.document_info?.[index]
                                    ?.document_name && (
                                    <div className="error-message">
                                      {
                                        errors.document_info[index]
                                          .document_name
                                      }
                                    </div>
                                  )}
                              </td>

                              {/* File Upload */}
                              <td>
                                <Field
                                  name={`document_info.${index}.company_documents`}
                                >
                                  {() => (
                                    <input
                                      type="file"
                                      className="modern-file"
                                      onChange={(event) =>
                                        handleFileChange(
                                          event,
                                          index,
                                          setFieldValue
                                        )
                                      }
                                    />
                                  )}
                                </Field>
                                {errors.document_info?.[index]
                                  ?.company_documents &&
                                  touched.document_info?.[index]
                                    ?.company_documents && (
                                    <div className="error-message">
                                      {
                                        errors.document_info[index]
                                          .company_documents
                                      }
                                    </div>
                                  )}
                              </td>

                              {/* View Button */}
                              <td className="centered">
                                <button
                                  type="button"
                                  className="icon-button view"
                                  disabled={
                                    !values.document_info[index]
                                      .company_documents
                                  }
                                  onClick={() => {
                                    const base64 =
                                      values.document_info[index]
                                        .company_documents;
                                    if (base64) {
                                      const newWindow = window.open();
                                      newWindow.document.write(
                                        `<img src="${base64}" alt="Uploaded Document" />`
                                      );
                                    }
                                  }}
                                >
                                  👁
                                </button>
                              </td>

                              {/* Action */}
                              <td className="centered">
                                {index > 4 && (
                                  <button
                                    type="button"
                                    className="icon-button delete"
                                    onClick={() => remove(index)}
                                  >
                                    <RiDeleteBinFill />
                                  </button>
                                )}
                                {index ===
                                  values.document_info.length - 1 && (
                                  <button
                                    type="button"
                                    className="icon-button add"
                                    onClick={() =>
                                      push({
                                        document_name: "",
                                        employee_documents: "",
                                      })
                                    }
                                  >
                                    <MdAddToPhotos />
                                  </button>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </>
                  )}
                </FieldArray>
              </div>
            </div>

            <div className="form-footer">
              <button type="submit" className="btn btn-submit">
                Submit
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}